// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"PlayOverlay_iconWrapper_1KC5mP9","zoomWrapper":"PlayOverlay_zoomWrapper_13rhn_n"};